{
  "UnifiedNavigation": "Navigate in the Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Select another org account",
  "help": "Help",
  "ok": "Ok",
  "profile": "Profile",
  "searchButton": "Search",
  "sidenavMenuCloseTooltip": "Close menu",
  "sidenavMenuLockTooltip": "Click to lock menu",
  "solutionSwitcher": "Switch to another Solution",
  "themeCoachMark": "Light Theme",
  "themeCoachMarkMessage": "Experience Cloud header now supports light and dark themes. Click on your avatar to toggle your preferred theme.",
  "toggleSideNav": "Toggle side navigation menu"
} 
